module.exports = __webpack_public_path__ + "static/media/logo.a2a1745b.png";